import { NavLink, Link } from "react-router-dom";
import logout_icon from "./../../../image/exit.png";
import pluriColor from "./../../../image/blue-logo.png";
import styles from "./app-header.module.scss";

function AppHeader() {
  return (
    <header className={`${styles.header} relative`}>
      <div className="flex items-center flex-1">
        <img
          src={pluriColor}
          width="60"
          height="60"
          alt="Pluritongues Logo"
          className="mx-3"
        />
        <h1 className="text-xl font-semibold text-center flex-1">
          Pluritongues LAMS
        </h1>
      </div>

      <Link
        to="/logout"
        className="absolute top-6 right-6 flex items-center justify-center 
               w-10 h-10 rounded-full bg-white shadow-md 
               transition-transform duration-200 hover:scale-110 hover:bg-gray-200"
      >
        <img
          src={logout_icon}
          alt="Logout"
          className="w-5 h-5 text-gray-800 cursor-pointer"
        />
      </Link>
    </header>
  );
}

export default AppHeader;
